import { ReactElement } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ProColors,
  ScreenSize,
  useIsScreenSize,
} from '@treatwell/treatwell-aura';
import { TFunction } from 'i18next';

export type FooterLeftComponentProps = {
  t: TFunction;
  isSMAndUnder: boolean;
};

export type FooterTemplateProps = {
  onPrevious?: () => Promise<void>;
  onNext?: () => Promise<void>;
  nextKey?: string;
  previousKey?: string;
  leftComponent?: ({ t }: FooterLeftComponentProps) => ReactElement | null;
};

export function FooterTemplate(props: FooterTemplateProps) {
  const { onPrevious, onNext, nextKey, previousKey, leftComponent } = props;
  const { t } = useTranslation('footer');
  const isSMAndUnder = useIsScreenSize(ScreenSize.SMAndUnder);

  return (
    <div
      css={css({
        height: 100,
        alignItems: 'center',
        display: 'flex',
        padding: isSMAndUnder ? '0 32px' : '0 40px',
        justifyContent: 'space-between',
        borderTop: `1px solid ${ProColors.navy[400]}`,
        gap: '16px',
      })}
    >
      {leftComponent && (
        <div css={css({ display: 'flex', alignItems: 'center', flex: 1 })}>
          {leftComponent?.({ t, isSMAndUnder })}
        </div>
      )}
      {onPrevious && previousKey && (
        <div css={css({ display: 'flex', alignItems: 'center', flex: 1 })}>
          <Button
            flavor="secondary"
            size="medium"
            onClick={onPrevious}
            block={isSMAndUnder}
          >
            {t(previousKey)}
          </Button>
        </div>
      )}
      {onNext && nextKey && (
        <div
          css={css({
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            justifyContent: 'flex-end',
          })}
        >
          <Button
            flavor="primary"
            size="medium"
            onClick={onNext}
            block={isSMAndUnder}
          >
            {t(nextKey)}
          </Button>
        </div>
      )}
    </div>
  );
}
